<template>
  <div class="__C_LabelValue" :class="[`align-${align}`]">
    <div class="__C_LabelValue_Label" :class="{ small: smallLabel }">
      {{ label }}
    </div>

    <div class="__C_LabelValue_Value">
      {{ value }}
      <slot v-if="$slots.default"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelValue',
  props: {
    label: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    align: {
      type: String,
      default: 'left',
      validator: function(value) {
        return ['left', 'center', 'right'].indexOf(value) !== -1;
      },
    },
    smallLabel: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.__C_LabelValue {
  margin-bottom: $space-xs;

  &_Label {
    line-height: $line-height;
    color: $neutral-secondary-color;
  }

  &.align-left {
    text-align: left;
  }

  &.align-center {
    text-align: center;
  }

  &.align-right {
    text-align: right;
  }

  &_Label {
    &.small {
      font-size: $font-size-sm;
    }
  }
}
</style>
